import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export function useDeliverers() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [deliverers, setDeliverers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDeliverers = useCallback(async () => {
    try {
      const res = await authAxiosRef.current.get("/deliverers");
      setDeliverers(res.data);
    } catch {
      toast.error("Erro ao carregar entregadores");
    }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { fetchDeliverers(); }, [fetchDeliverers]);

  const toggleActive = async (id) => {
    try {
      await authAxiosRef.current.patch(`/deliverers/${id}/toggle-active`);
      fetchDeliverers();
    } catch {
      toast.error("Erro");
    }
  };

  return { deliverers, loading, fetchDeliverers, toggleActive };
}
